import { useCallback, useEffect, useState } from "react";
import ExtraPayService from "../../../../../../service/ExtraPayService";
import { EXTRAPAY_SUCCESS_CODE } from "../constants";

const useExtrapayWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const reload = useCallback(async () => {
    const token = localStorage.getItem("__extraconomy_token");
    const username = localStorage.getItem("__extraconomy_username");
    const service = new ExtraPayService(token);
    setIsLoading(true);
    setHasError(false);

    try {
      const response = await service.listWithdrawalsByUser(username);
      if (response?.messageCode !== EXTRAPAY_SUCCESS_CODE) {
        setHasError(true);
        setWithdrawals([]);
        return { ok: false, code: response?.messageCode };
      }
      setWithdrawals(Array.isArray(response.result) ? response.result : []);
      return { ok: true };
    } catch (error) {
      setHasError(true);
      setWithdrawals([]);
      return { ok: false };
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { withdrawals, isLoading, hasError, reload };
};

export default useExtrapayWithdrawals;
